import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import NavBar from "../components/NavBar";
import API from "../api";
import { ArrowLeft, Copy, ExternalLink } from "lucide-react";

export default function CricketController() {
  const { matchId } = useParams();
  const navigate = useNavigate();
  const [match, setMatch] = useState(null);
  const [err, setErr] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    API.get(`/matches/${matchId}`).then(r => setMatch(r.data)).catch(e => {
      setErr(e.response?.data?.detail || "Match not found");
    });
  }, [matchId]);

  const overlayUrl = `${window.location.origin}/overlay/${matchId}`;

  const copyOverlay = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(overlayUrl);
      } else {
        const ta = document.createElement("textarea");
        ta.value = overlayUrl; document.body.appendChild(ta);
        ta.select(); document.execCommand("copy"); document.body.removeChild(ta);
      }
      setCopied(true); setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      window.prompt("Copy this Overlay URL:", overlayUrl);
    }
  };

  if (err) return (
    <div className="min-h-screen bg-slate-950"><NavBar /><div className="pt-24 max-w-4xl mx-auto px-6 text-center">
      <div className="p-6 bg-red-500/10 border border-red-800 rounded-xl text-red-300">{err}</div>
      <button onClick={() => navigate("/matches")} className="mt-4 px-4 py-2 rounded bg-blue-600">Back to Matches</button>
    </div></div>
  );
  if (!match) return <div className="min-h-screen bg-slate-950"><NavBar /><div className="pt-24 text-center text-slate-400">Loading match...</div></div>;

  const token = localStorage.getItem("token") || "";
  const backend = process.env.REACT_APP_BACKEND_URL;
  const iframeSrc = `/admin-controller.html?matchId=${matchId}&token=${encodeURIComponent(token)}&backend=${encodeURIComponent(backend)}`;

  return (
    <div className="min-h-screen bg-slate-950">
      <NavBar subtitle={match.name} />
      <div className="pt-20 pb-4 px-6 max-w-[1500px] mx-auto flex items-center justify-between flex-wrap gap-3">
        <Link to="/matches" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white" data-testid="back-to-matches">
          <ArrowLeft size={14}/> Back to Matches
        </Link>
        <div className="flex items-center gap-2">
          <div className="text-xs text-slate-400 hidden md:block mr-2">Overlay:</div>
          <code data-testid="overlay-url-display" className="hidden md:block text-xs bg-slate-800 border border-slate-700 rounded px-2 py-1 text-slate-300 max-w-md truncate">{overlayUrl}</code>
          <button onClick={copyOverlay} data-testid="copy-overlay-button" className="inline-flex items-center gap-2 px-3 py-1.5 rounded bg-slate-800 hover:bg-slate-700 border border-slate-700 text-sm">
            <Copy size={14}/> {copied ? "Copied!" : "Copy Overlay URL"}
          </button>
          <a href={overlayUrl} target="_blank" rel="noreferrer" data-testid="open-overlay-button" className="inline-flex items-center gap-2 px-3 py-1.5 rounded bg-blue-600 hover:bg-blue-700 text-sm font-semibold">
            <ExternalLink size={14}/> Preview
          </a>
        </div>
      </div>
      <div className="max-w-[1500px] mx-auto px-2 pb-8">
        <iframe
          title="Cricket Controller"
          src={iframeSrc}
          data-testid="controller-iframe"
          className="w-full bg-slate-100 rounded-xl border border-slate-800"
          style={{ height: "calc(100vh - 140px)", minHeight: 700 }}
        />
      </div>
    </div>
  );
}
